'use strict'

import { getContactsData } from '../../crm/crm-requests';

export const contactsData = async () => {
    const response = await getContactsData();
    const settings = await response.data;
    let data = [];
    const iconsArray = [
        {
            title: 'phones',
            icon: 'icon-call_filled',
        },
        {
            title: 'emails',
            icon: 'icon-email',
        },
        {
            title: 'website',
            icon: 'icon-site'
        },
        {
            title: 'phone',
            icon: 'icon-call_filled',
        },
        {
            title: 'email',
            icon: 'icon-email',
        },
    ];

    for (let [key, value] of Object.entries(settings)) {
        let iconValue = iconsArray.find(item => item.title === key);
        let object = [];

        if (Array.isArray(value)) {
            value.forEach((item, i) => {
                object.push({
                    title: key,
                    crmData: value[i],
                    icon: iconValue ? iconValue.icon : '',
                })
            })
        } else {
            object.push({
                title: key,
                crmData: value,
                icon: iconValue ? iconValue.icon : '',
            });
        }

       data = data.concat(object);
    }

    return data;
}